import axios from 'axios'
import { getParameter } from 'helpers/general-helper';
import moment from 'moment';
import toast from 'react-hot-toast';

const generateBill = async (data, header, user) => {
    var result = await createBill(data, header, user)

    return result
}

const createBill = async (data, header, user) => {
    const bill_due_date = getParameter("BILL_DUE_DATE")
    const tmpDate = new Date();
    var dueDate = new Date();
    dueDate.setDate(dueDate.getDate() + Number(bill_due_date));
    
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

    try {
        let response = await axios.post(`${process.env.REACT_APP_CASHIER_API_URL}/bill/store`, {
            bill_number: "PO-" + data?.id,
            reference_number: data?.id,
            branch_id: data?.outlet_id,
            currency: data?.currency_id,
            rate: data?.rate,
            dpp: header?.dpp_amount,
            ppn: header?.ppn_amount,
            ppn_percentage: data?.ppn_percentage,
            discount: header?.discount_amount,
            grand_total: header?.nett_amount,
            type: 'po',
            transaction_type: 1, //1 uang keluar
            status: 'outstanding',
            created_by: user?.name,
            bill_date: moment(tmpDate).format('YYYY-MM-DD HH:mm:ss'),
            due_date: moment(dueDate).format('YYYY-MM-DD HH:mm:ss'),
            payor_or_payee: {
                type: 'supplier',
                code: data?.supplier_phone_number,
                name: data?.supplier_name,
                phone: data?.outlet_phone_number,
                mobile: data?.outlet_phone_number,
            }
        });
        if (response.data.message === "Successfully created a new bill!") {
            toast.success("Bill created!")
            return true
        } else {
            toast.success(JSON.stringify(response))
            return false
        }    
    } catch (err) {
        toast.error('on error : ' + JSON.stringify(err.response.data));
        return false
    }
}

// const updateBill = async (data, user) => {
//     axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

//     try {
//         let response = await axios.patch(`${process.env.REACT_APP_BACKEND_URL}/bill/update`, {
//             bill_number: data?.sales_order_id,
//             status: 'paid',
//             updated_by: user?.name
//         });
//         if (response.data.message === "Successfully updated a bill!") {
//             toast.success("Bill updated!")
//             return true
//         } else {
//             toast.success(JSON.stringify(response))
//             return false
//         }    
//     } catch (err) {
//         toast.error('on error : ' + JSON.stringify(err.response.data));
//         return false
//     }
// }

// const generateInvoice = async (data, user) => {
//     const tmpDate = new Date();
//     var dueDate = new Date();
//     dueDate.setDate(dueDate.getDate() + 14);

//     axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

//     try {
//         let response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/invoice/store`, {
//             source: 'SS',
//             payor_or_payee_code: data?.outlet_group_id + '-' + data?.outlet_id,
//             branch_id: data?.outlet_id,
//             currency: data?.currency_id,
//             rate: data?.rate,
//             dpp: data.dpp_amount,
//             ppn: data.ppn_amount,
//             ppn_percentage: data.ppn_percentage,
//             // pph: 0,
//             // pph_percentage: 0,
//             rebate: 0,
//             discount: data.discount_amount,
//             grand_total: data.nett_amount,
//             // advance_payment: 0,
//             note: '',
//             tax_invoice_number: '',
//             type: 'ord',
//             transaction_type: 0,
//             invoice_type: 1,
//             status: 1,
//             created_by: user?.name,
//             approved_by: user?.name,
//             invoice_date: tmpDate.toISOString().slice(0, -1),
//             due_date: dueDate.toISOString().slice(0, -1),
//             invoice_detail: [{
//                 price: data.amount,
//                 discount: data.discount_amount,
//                 ppn: data.ppn_amount,
//                 subtotal: data.nett_amount,
//                 description: '',
//                 bill_number: data?.public_id,       
//             }]
//         });
//         if (response.data.message === "Berhasil membuat data invoice!") {
//             data.invoice_number = response.data.data.invoice.invoice_number
//             toast.success("Invoice created!")
//             return true
//         } else {
//             toast.success(JSON.stringify(response))
//             return false
//         }    
//     } catch (err) {
//         toast.error('on error : ' + JSON.stringify(err.response.data));
//         return false
//     }
// }

// const createTransaction = async (data, user) => {
//     const tmpDate = new Date();
//     var dueDate = new Date();
//     dueDate.setDate(dueDate.getDate() + 14);

//     axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

//     try {
//         let response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/pay`, {
//             payor_or_payee_code: data?.outlet_group_id + '-' + data?.outlet_id,
//             branch_id: data?.outlet_id,
//             currency: 'IDR',
//             rate: 1,
//             // advance_payment: 0,
//             note: '',
//             type: 'ord',
//             transaction_type: 0,
//             status: 'settled',
//             created_by: user?.name,
//             transaction_date: tmpDate.toISOString().slice(0, -1),
//             due_date: data.entry_date,
//             transaction_detail: [{
//                 invoice_number: data.invoice_number,
//                 amount: data.nett_amount        
//             }],
//             grand_total: data.nett_amount,
//             transaction_payment_account: {
//                 coa_number: data.coa_number,
//                 payment_type: data.payment_type,
//                 account_number: data.account_number,
//                 giro_due_date: data.entry_date,
//                 amount: data.nett_amount      
//             }
//         });
//         if (response.data.message === "Berhasil membuat data pembayaran invoice!") {
//             toast.success("Payment created!")
//             return true
//         } else {
//             toast.success(JSON.stringify(response))
//             return false
//         }    
//     } catch (err) {
//         toast.error('on error : ' + JSON.stringify(err.response.data));
//         return false
//     }
// }

export default generateBill